/**
 * Die einzelnen Wareneingangsbuchungen je Bestellposition - Datenquelle des Drawer-Reiters
 * "Anlieferung" (siehe Drawer/ArrivalTab/Anlieferungsliste.tsx). Backend: backend/src/jtl/
 * einbuchungen.ts.
 */
import { anfrage } from "./basis.ts";

export interface JtlEinbuchung {
  datum: string | null;
  menge: number | null;
  benutzer: string | null;
  /**
   * Fruehester/spaetester Buchungszeitpunkt (HH:MM) innerhalb der Tagesgruppe - passend zum
   * Backend-Typ (`backend/src/jtl/einbuchungen.ts#JtlEinbuchung`), Auftrag "Lieferstatus-Icons +
   * Uhrzeit", 2026-08-28. `null`, wenn die Uhrzeit nicht lesbar ist.
   */
  zeitVon: string | null;
  zeitBis: string | null;
}

export interface EinbuchungenJePosition {
  kLieferantenBestellungPos: number;
  einbuchungen: JtlEinbuchung[];
}

/**
 * `jtlOrderId` ist die NUMERISCHE JTL-Kennung (`Order.jtlOrderId`, nicht die Hub-eigene
 * `Order.id`) - dieselbe Bauart wie `teillieferungAnlegen`/`drawerJtlUebertragen` in App.tsx, die
 * ebenfalls direkt gegen /api/jtl/orders/:k/... rufen.
 */
export function einbuchungenLaden(
  jtlOrderId: number,
  signal?: AbortSignal,
): Promise<EinbuchungenJePosition[]> {
  return anfrage<{ positionen: EinbuchungenJePosition[] }>(
    `/api/jtl/orders/${jtlOrderId}/einbuchungen`,
    { signal },
  ).then((antwort) => antwort.positionen);
}
